module.exports = __webpack_public_path__ + "static/media/battle-field.01b42be1.png";